// extracted by mini-css-extract-plugin
module.exports = {"box_container":"styles_box_container__vbzId","hide":"styles_hide__I6sRc"};